
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { DomainType } from 'prismic/config';
import { getDocumentRelationsFromFile } from 'prismic/getDocumentRelations';
import { fetchDocumentContent } from 'prismic/helpers/fetchContent';
import { getPageTypeFromSlug } from 'prismic/helpers/getPageTypeFromSlug';
import { NextGuidePageProps, ServerSideGuideProps, ServerSideGuidePropsResult } from 'types/pages';
import { mapNextLocaleToISOLanguageCode } from 'helpers/locale.helper';
import { getLastFromSlug } from 'helpers/path.helper';
import GuideTemplate from 'components/templates/GuideTemplate';

const Page: NextGuidePageProps = ({ header, data, footer }) => {
  return <GuideTemplate data={data} header={header} footer={footer} />;
};

 async function _getServerSideProps({
  locale,
  params,
}: ServerSideGuideProps): ServerSideGuidePropsResult {
  const { segments, domain } = params;

  const documentRelations = await getDocumentRelationsFromFile();

  const uid = getLastFromSlug(segments) || 'guide';
  const pageType = getPageTypeFromSlug(segments);

  const fetchedContent = await fetchDocumentContent({
    lang: mapNextLocaleToISOLanguageCode(locale),
    domain: domain as DomainType,
    isValidPath: true,
    uid,
    pageType,
  });

  if (!fetchedContent?.data) {
    console.error(`No content found ->`, {
      lang: mapNextLocaleToISOLanguageCode(locale),
      domain: domain as DomainType,
      isValidPath: true,
      uid,
      pageType,
    });

    return {
      notFound: true,
    };
  }

  const { data, header, footer, type } = fetchedContent;

  return {
    props: {
      type,
      header,
      footer,
      data,
      documentRelations,
      sharedData: null,
      domain: domain as DomainType,
      guideData: {
        isGuide: true,
      },
    },
  };
}

export default Page;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/[domain]/guide/[[...segments]]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  